export const fonts = {
  alt: `var(--font-alt, "Duplicate Sans")`,
  faktum: `var(--font-faktum, "Faktum")`,
  main: `var(--font-main, "Roboto")`,
};
